export default __webpack_public_path__ + "static/media/Eternals.8a242533.jpg";